import initHeaderNav from "@/common/header-nav/header-nav";
import { hydrate, observe, prefetchFromAnchors } from "@modules/hydrate/hydrate";
import initLenis from "@modules/lenis/initLenis";
import initScrollTop from "@modules/scrollTop/scrollTop";

initScrollTop();
initHeaderNav();
hydrate();
observe();

window.__lenisInit = initLenis()
    .catch((error) => {
        console.error("[Lenis] Failed to initialize", error);
    })
    .finally(() => {
        prefetchFromAnchors();
    });

// RGPD open consent form
document.querySelector('a[href="#rgpd"]')?.addEventListener('click', (e) => {
    e.preventDefault();
    window.ppms?.cm?.api?.('openConsentForm');
});
